<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg8>
          <v-card class="elevation-2">
            <v-card-title>Capture or Upload Image</v-card-title>
            <v-card-text v-if="!mediaUrl">
              <gen-img-uploader
                  autoLoad="true"
                  path="quoteImages"
                  :quoteId="quoteId"
                  @imageLinkFound="addImageLink"
                  @removeImage="removeImageLink">
              </gen-img-uploader>
            </v-card-text>
            <div v-if="mediaUrl">
              <v-img :src=mediaUrl></v-img>
              <app-loading v-if="loading"></app-loading>
<!--              <map style="border-style: solid; border-color: greenyellow" name="annonMap" id="annonMap">-->
<!--&lt;!&ndash;                <div v-for="obj in annonObj" :key="obj.id" >{{obj.name}} = {{obj.boundingPoly.normalizedVertices}}</div>&ndash;&gt;-->
<!--                <area alt="Computer" target="" coords="20,500,81,200" shape="rect" >-->
<!--              </map>-->
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>
<script>
import {collection, setDoc, onSnapshot, doc} from "firebase/firestore";
// import {getAuth, onAuthStateChanged} from "firebase/auth";
import { getFunctions, httpsCallable  } from 'firebase/functions';
import {v1 as uuidv1} from "uuid";

export default {
  props: ['publicListingId', 'listingId'],
  data: () => ({
    mediaUrl: undefined,
    annotatedImage: null,
    quoteId: uuidv1(),
    annonObj: null,
    itemId: 'autoImgRecognition',
    itemType: 'mlItem',
    addOnItems: null
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created () {
    let db = this.$store.state.db
    let itemsRef = collection(db, 'publicListings',
        this.publicListingId + '/listings/' + this.listingId + '/addOnItems')
    onSnapshot(itemsRef, res => {
      // console.log(res)
      if (res && res.empty !== true) {
        let items = []
        let sortedItems = []
        res.forEach(doc => {
          let data = doc.data()
          items.push(data)
        })
        // console.log(items)
        sortedItems = items.sort((a, b) => a.title.localeCompare(b.title))
        this.addOnItems = sortedItems
      }
      this.$store.dispatch('setLoading', false)
    })
  },
  methods: {
    removeImageLink() {
      this.mediaUrl = undefined
    },
    addImageLink(link) {
      //console.log(link)
      let annotatedImages
      let detectedItems = []
      this.$store.dispatch('setLoading', true)
      this.mediaUrl = link.url
      let db = this.$store.state.db
      let quoteRef = doc(db, 'anonUsers', this.user.uid, 'quotes', this.quoteId)
      //console.log(this.publicListingId +" " + this.listingId)
      const functions = getFunctions()
      const annotateImage = httpsCallable(functions, 'annotateImageToItems')
      annotateImage({fileName: link.imgLocation})
          .then(res => {
            if (res.data) {
              annotatedImages = res.data.annotatedImage
              console.log(annotatedImages)
            }
          })
          .then(() => {
            if (annotatedImages.length !== 0) {
              let objects = annotatedImages.objects
              if (this.addOnItems) {
                let items = this.addOnItems
                objects.forEach(object => {
                  let matchedItem = items.find(item => {
                    return object.name === item.title
                  })
                     if (matchedItem) {
                       let mlObject = matchedItem
                       mlObject.mlObject = true
                       mlObject.normalizedVerticies = object.boundingPoly.normalizedVertices
                       mlObject.score = object.score
                       mlObject.imgs = [{id: link.id, url: link.url}]
                       mlObject.qty = 1
                       detectedItems.push(mlObject)
                     } else {
                       let item = {
                         created: Date.now(),
                         customItem: false,
                         id: object.mid,
                         mlObject: true,
                         normalizedVerticies: object.boundingPoly.normalizedVertices,
                         score: object.score,
                         imgs:[{id: link.id, url: link.url}],
                         instruction: '',
                         kmPrice: 0,
                         listed: false,
                         minutePrice: "30",
                         note: '',
                         qty: 1,
                         title: object.name,
                         unitPrice: 0
                       }
                       detectedItems.push(item)
                     }
                })
                console.log(detectedItems)
              }
            }
          })
          .then(() => {
            if (detectedItems.length !== 0) {
              let quoteObj = {
                id: this.quoteId,
                listingId: this.listingId,
                itemId: this.itemId,
                addOnItems: detectedItems
              }
              console.log(quoteObj)
              return setDoc(quoteRef, quoteObj)
            } else {
              this.$store.dispatch('setError', {message: 'Auto detection failed. Please try again.'})
            }
          })
          .then(() => {
            this.$store.dispatch('setLoading', false)
            if (detectedItems.length !== 0) {
              this.$router.push('/quotes/' + this.publicListingId + '/'
                  + this.listingId + '/' + this.itemType + '/' + this.itemId + '/' + this.quoteId)

            }
          })
          .catch(err => {
            console.log(err)
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('setError', err)
          })

      // return setDoc(quoteRef, {id: this.quoteId, listingId: this.listingId, itemId: this.itemId})
      //     .then(() => {
      //       this.$store.dispatch('setLoading', false)
      //       this.$router.push('/quotes/' + this.publicListingId + '/'
      //           + this.listingId + '/' + this.itemType + '/' + this.itemId + '/' + this.quoteId)
      //     })
      //     .catch(error => {
      //       console.log(error)
      //       this.$store.dispatch('setLoading', false)
      //       this.$store.dispatch('setError', error)
      //     })
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

